import { QuotaCleanerItem } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { UserQuotaGroupType } from 'reactApp/types/QuotaCleaner';
import opener from 'reactApp/utils/opener';
import { getEncodePath, getHomeFolderPath } from 'reactApp/utils/urlHelper';

export const openItemView = (item: QuotaCleanerItem) => {
    const { groupType, viewPath } = item;
    let url = viewPath;

    if (groupType === UserQuotaGroupType.Cloud) {
        url = getHomeFolderPath(getEncodePath(viewPath));
    }

    opener(url);
};
